export default __webpack_public_path__ + "static/media/jee_step_2.40d93023.svg";